import Types from "../../constants/Types.js";
export default {
  name: 'state',
  objectType: Types.firmwareRelease,
  valueType: 'string',
  get: (data, cxt) => {
    return data?.state;
  },
  displayName: 'State',
  source: {
    type: Types.apiName,
    editable: false,
    creatable: false
  }
};